export default "__VITE_ASSET__4c87c619__"